<div class="container">
    <div class="row mb-3" *ngIf="vehicle">
        <div class="col">

            <h2 class="my-4" i18n>Vehículo</h2>

            <div class="card">
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label for="vehicle" class="form-label"><span i18n>Matrícula</span>: </label>
                        <input type="text" class="form-control" id="vehicle" [(ngModel)]="vehicle.vehiclePlate">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label for="chassis" class="form-label"><span i18n>Alias</span>: </label>
                        <input type="text" class="form-control" id="chassis" [(ngModel)]="vehicle.vehicleAlias">
                    </div>
                    <div class="col-12 mb-3 check-legal">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="vehicle.ownerDeclaration" id="titular">
                        <label for="titular" class="form-label ml-3 label-checkbox"><span i18n>¿Soy el titular del vehículo?</span></label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mb-5">
        <div class="col text-center btn-actions">
            <button type="button" class="btn btn-primary" (click)="create()" i18n>Crear</button>
            <button type="button" class="btn btn-secondary" (click)="goBack()" i18n>Volver</button>
        </div>
    </div>
</div>